import { render } from "./Order.vue?vue&type=template&id=4789b98b&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=4789b98b&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\cazino\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4789b98b"]])

export default __exports__